import { Group } from '@mantine/core';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '../../../../../ui-library/select/select';
import { Text } from '../../../../../ui-library/typography/typography';
import { getSortOptions } from './side-section.data';
import { WorkUnitsSortOption } from './side-section.type';

type Props = {
  sortBy: WorkUnitsSortOption;
  onSortChange: (sortBy: WorkUnitsSortOption) => void;
};

export const SideSectionWorkUnitsSort = ({ sortBy, onSortChange }: Props) => {
  const i18n = useTranslation();
  const sortOptions = useMemo(() => getSortOptions(i18n.t), [i18n.t]);
  return (
    <Group justify="space-between" align="center" wrap="nowrap">
      <Text size="small" weight="medium" style={{ flexShrink: 0 }}>
        {i18n.t('process_analysis.work_units.sort_by')}
      </Text>
      <Select
        value={sortBy}
        options={sortOptions}
        onChange={(value) => onSortChange(value as WorkUnitsSortOption)}
        size="sm"
        radius="xl"
        style={{ minWidth: 160, flexShrink: 0 }}
      />
    </Group>
  );
};
